import { useCallback, useEffect } from 'react';
import { PrimitiveAtom, useAtomValue, useSetAtom } from 'jotai';
import queryString from 'query-string';
import { updateUrl } from '@/utils';

export type ViewpointsDeeplinkState = {
  shouldUpdateUrl: boolean;
  showViewpointsAtom: PrimitiveAtom<boolean>;
};

export const useViewpointsDeeplink = (state: ViewpointsDeeplinkState) => {
  const { shouldUpdateUrl, showViewpointsAtom } = state;

  const showViewpoints = useAtomValue(showViewpointsAtom);
  const setShowViewpoints = useSetAtom(showViewpointsAtom);

  useEffect(() => {
    if (shouldUpdateUrl) {
      updateUrl('showViewpoints', showViewpoints ? 'true' : undefined);
    }
  }, [shouldUpdateUrl, showViewpoints]);

  const applyFromParsed = useCallback(
    (parsed: queryString.ParsedQuery<string>) => {
      if (parsed.showViewpoints === 'true') setShowViewpoints(true);
    },
    [setShowViewpoints]
  );

  return { applyFromParsed };
};
